export default __webpack_public_path__ + "static/media/play_btn.54a2e8c5.svg";